"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingInfoForm = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _consts = require("../../../consts");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// Styles
var customPersonalInfoInputStyle = "flex-1 border border-neutral-400 rounded-md px-4 py-[13.5px] shadow text-black text-base placeholder:font-medium placeholder:text-[#757575]";
var customMuiBorderStyle = {
  borderWidth: "1px",
  borderColor: "#CACACA"
};
var customSelectSx = {
  padding: "15px",
  boxShadow: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
  borderRadius: "0.375rem",
  "& .MuiSelect-select": {
    padding: 0,
    color: "#757575"
  },
  "& .MuiOutlinedInput-notchedOutline": customMuiBorderStyle,
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": customMuiBorderStyle,
  "&:hover .MuiOutlinedInput-notchedOutline": customMuiBorderStyle
};
var BillingInfoForm = exports.BillingInfoForm = function BillingInfoForm(_ref) {
  var firstName = _ref.firstName,
    lastName = _ref.lastName,
    city = _ref.city,
    state = _ref.state,
    zipcode = _ref.zipcode,
    setFirstName = _ref.setFirstName,
    setLastName = _ref.setLastName,
    setCity = _ref.setCity,
    setState = _ref.setState,
    setZipcode = _ref.setZipcode,
    setFormError = _ref.setFormError;
  var handleLetters = function handleLetters(e, callback) {
    var value = e.target.value;
    var regex = /^[A-Za-z\s]*$/;
    if (regex.test(value) || value === "") {
      callback(value);
      setFormError("");
    }
  };
  var handleZipcode = function handleZipcode(e) {
    var value = e.target.value;
    value = value.replace(/\D/g, "");
    if (value.length > 5) value = value.slice(0, 5);
    setZipcode(value);
    setFormError("");
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-blue-600 font-bold"
  }, "Billing Info"), /*#__PURE__*/_react["default"].createElement("div", {
    id: "personal-info",
    className: "mt-4 flex flex-col space-y-3"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: customPersonalInfoInputStyle,
    type: "text",
    placeholder: "First Name",
    onChange: function onChange(e) {
      return handleLetters(e, setFirstName);
    },
    value: firstName,
    maxLength: 26
  }), /*#__PURE__*/_react["default"].createElement("input", {
    className: customPersonalInfoInputStyle,
    type: "text",
    placeholder: "Last Name",
    onChange: function onChange(e) {
      return handleLetters(e, setLastName);
    },
    value: lastName,
    maxLength: 26
  }), /*#__PURE__*/_react["default"].createElement("input", {
    className: customPersonalInfoInputStyle,
    type: "text",
    placeholder: "City",
    onChange: function onChange(e) {
      return handleLetters(e, setCity);
    },
    value: city,
    maxLength: 45
  }), /*#__PURE__*/_react["default"].createElement(_material.Select, {
    labelId: "chargebee-card-select-country",
    value: "United States",
    onChange: function onChange() {},
    sx: customSelectSx
  }, /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
    value: "United States"
  }, "United States")), /*#__PURE__*/_react["default"].createElement("input", {
    className: customPersonalInfoInputStyle,
    type: "text",
    placeholder: "ZIP",
    onChange: handleZipcode,
    value: zipcode
  }), /*#__PURE__*/_react["default"].createElement(_material.Select, {
    sx: customSelectSx,
    value: state,
    onChange: function onChange(e) {
      setState(e.target.value);
      setFormError("");
    },
    MenuProps: {
      PaperProps: {
        sx: {
          maxHeight: 300,
          overflowY: "auto"
        }
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
    value: "State",
    disabled: true
  }, "State"), _consts.US_STATES.map(function (_ref2) {
    var longState = _ref2.name;
    return /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
      key: longState,
      value: longState
    }, longState);
  }))));
};